<template>
  <section>
    <NavBar />
    <div class="hero is-bold" :class="$style.customHero">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div id="textblock" class="column">
              <h2 class="title">Contacto</h2>
              <h5 class="subtitle">
                Descubre cómo nuestros productos empresariales se alinean con
                las necesidades de tu organización.
              </h5>
            </div>
            <div class="column has-text-centered">
              <img
                style="max-width: 46%;"
                :class="$style.heroImg"
                :src="heroImage"
                alt="hero"
                title="contact hero"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="section">
      <div class="container">
        <div class="columns mt-6-xs py-6-xs">
          <div class="column is-7">
            <h2 class="title is-2">
              Ponte en contacto con nosotros
            </h2>
            <div class="my-5 my-md-6 my-lg-7" :class="$style.hairline"></div>
            <p class="subtitle">
              ¿Tienes curiosidad por nuestro producto, quieres hablar con Ventas
              o simplemente quieres saber más sobre nuestro producto? ¡Ingresa
              tu información en el formulario, describa su consulta y nos
              pondremos en contacto contigo lo antes posible!
            </p>
            <div style="max-width: 50%; height: auto;">
              <img class="is-hidden-mobile" :src="manContact" alt />
            </div>
          </div>
          <div class="column">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </section>
</template>

<script>
import { NavBar, Footer, ContactForm } from "@/components";
import { heroContact, manContact } from "@/assets/images";

export default {
  name: "Contact",
  components: {
    NavBar,
    Footer,
    ContactForm,
  },
  data: () => {
    return {
      heroImage: heroContact,
      manContact: manContact,
    };
  },
};
</script>

<style lang="scss" module>
.customHero {
  background: linear-gradient(
    0deg,
    rgba(27, 115, 232, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
}

.hairline {
  border-bottom: 1px solid #d8d8d8;
  height: 1px;
  width: 100%;
}
</style>
